import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { FilterOperators } from 'src/app/common/enums/filter-operators';
import { PropertyFilterOperator } from 'src/app/common/interfaces/property-filter-operator';
import { buildFilterArray } from 'src/app/common/utils/build-filter-array';
import { DictionaryService } from 'src/app/data/dictionary.service';
import { Filter } from 'src/app/models/common/filter';
import { DictionaryItem } from 'src/app/models/DictionaryItem';

@Component({
  selector: 'app-delegation-list-filters',
  templateUrl: './delegation-list-filters.component.html',
  styleUrls: ['./delegation-list-filters.component.scss'],
  standalone: false
})
export class DelegationListFilterComponent implements OnInit, OnDestroy {
  private dictionaryService = inject(DictionaryService);

  @Input() formGroup: UntypedFormGroup;
  @Output() filterGridData = new EventEmitter<Filter[]>();
  private readonly unsubscribe$ = new Subject<void>();

  statuses$: Observable<DictionaryItem[]> = this.dictionaryService.getDelegationStatuses();

  public static readonly operatorsMap: Map<string, PropertyFilterOperator> = new Map<string, PropertyFilterOperator>([
    ['firstName', { property: 'FirstName', operator: FilterOperators.Contains }],
    ['lastName', { property: 'LastName', operator: FilterOperators.Contains }],
    ['startDate', { property: 'StartDate', operator: FilterOperators.DateGreaterThanOrEqual }],
    ['endDate', { property: 'EndDate', operator: FilterOperators.DateLessThanOrEqual }],
    ['status', { property: 'StatusId', operator: FilterOperators.Equal }],
    ['pesel', { property: 'Pesel', operator: FilterOperators.StringEqual }],
    ['document', { property: 'Document', operator: FilterOperators.Contains }],
    ['client', { property: 'Client', operator: FilterOperators.Contains }],
    ['pesel', { property: 'Pesel', operator: FilterOperators.StringEqual }],
  ]);

  constructor() { }

  ngOnInit(): void {
    this.formGroup.valueChanges.pipe(takeUntil(this.unsubscribe$), debounceTime(1000)).subscribe(() => {
      if (this.formGroup.invalid) return;
      this.filterGridData.emit(buildFilterArray(this.formGroup, DelegationListFilterComponent.operatorsMap));
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
